import types from './types'

export const showAddContactDialog = (company, defaults) => ({ type: types.SHOW_CONTACT_DIALOG, data: { company, defaults } })
export const showEditContactDialog = (contact) => ({ type: types.SHOW_CONTACT_DIALOG, data: { contact } })
export const hideContactDialog = () => ({ type: types.HIDE_CONTACT_DIALOG })

export const showAddCompanyDialog = (defaults) => ({ type: types.SHOW_COMPANY_DIALOG, data: { defaults } })
export const showEditCompanyDialog = (company) => ({ type: types.SHOW_COMPANY_DIALOG, data: { company } })
export const hideCompanyDialog = () => ({ type: types.HIDE_COMPANY_DIALOG })

export const showAddApprovalDialog = (data = {}) => ({ type: types.SHOW_ADD_APPROVAL_DIALOG, data })
export const hideAddApprovalDialog = () => ({ type: types.HIDE_ADD_APPROVAL_DIALOG })

export const showAddQuoteDialog = ({ company, contact, order, opportunity } = {}) => ({ type: types.SHOW_ADD_QUOTE_DIALOG, data: { company, contact, order, opportunity} })
export const hideAddQuoteDialog = () => ({ type: types.HIDE_ADD_QUOTE_DIALOG })

export const showAddInvoiceDialog = (order, creditNote) => ({ type: types.SHOW_ADD_INVOICE_DIALOG, data: { order, creditNote } })
export const hideAddInvoiceDialog = () => ({ type: types.HIDE_ADD_INVOICE_DIALOG })

export const showAddBulkInvoicesDialog = (quotations = []) => ({ type: types.SHOW_ADD_BULK_INVOICES_DIALOG, data: { quotations } })
export const hideAddBulkInvoicesDialog = () => ({ type: types.HIDE_ADD_BULK_INVOICES_DIALOG })
export const updateAddBulkInvoicesDialog = (invoicedDateOption) => ({ type: types.UPDATE_ADD_BULK_INVOICES_DIALOG, data: { invoicedDateOption } })

export const showAddActivityDialog = (data = {}) => ({ type: types.SHOW_ACTIVITY_DIALOG, data })
export const hideAddActivityDialog = () => ({ type: types.HIDE_ACTIVITY_DIALOG })

export const showEditActivityDialog = ( activity ) => ({ type: types.SHOW_ACTIVITY_DIALOG, data: { activity } })
export const hideEditActivityDialog = () => ({ type: types.HIDE_ACTIVITY_DIALOG })

export const showAddDeliveryNoteDialog = (orderId, returnNote = false) => ({ type: types.SHOW_DELIVERY_NOTE_DIALOG, orderId, returnNote })
export const showEditDeliveryNoteDialog = (deliveryNote) => ({ type: types.SHOW_DELIVERY_NOTE_DIALOG, deliveryNote })
export const hideDeliveryNoteDialog = () => ({ type: types.HIDE_DELIVERY_NOTE_DIALOG })

export const showOpportunityDialog = (isAdding = true, company, contact) => ({type: types.SHOW_OPPORTUNITY_DIALOG, isAdding, company, contact})
export const hideOpportunityDialog = () => ({type: types.HIDE_OPPORTUNITY_DIALOG })

export const deliveryNoteDialogInitialiseAttempt = (orderId, onSuccess) => ({ type: types.DELIVERY_NOTE_DIALOG_INITIALISE_ATTEMPT, orderId, onSuccess })
export const deliveryNoteDialogInitialiseSuccess = (order) => ({ type: types.DELIVERY_NOTE_DIALOG_INITIALISE_SUCCESS, order })
export const deliveryNoteDialogInitialiseFailure = (error, code) => ({ type: types.DELIVERY_NOTE_DIALOG_INITIALISE_FAILURE, error, code })

export const deliveryNoteDialogAddItems = (deliveryNote, orderItems) => ({ type: types.DELIVERY_NOTE_DIALOG_ADD_ITEMS, deliveryNote, orderItems })
export const deliveryNoteDialogDeleteItems = (deliveryNoteItems) => ({ type: types.DELIVERY_NOTE_DIALOG_DELETE_ITEMS, deliveryNoteItems })
export const deliveryNoteDialogReset = () => ({ type: types.DELIVERY_NOTE_DIALOG_RESET })

export const showDeleteDeliveryNoteFailurePrompt = (message) => ({type: types.SHOW_DELETE_DELIVERY_NOTE_FAILURE_PROMPT, message})
export const hideDeleteDeliveryNoteFailurePrompt = () => ({type: types.HIDE_DELETE_DELIVERY_NOTE_FAILURE_PROMPT})

export const loadActivity = (id) => ({ type: types.DIALOG_LOAD_ACTIVITY_ATTEMPT, id })
export const loadActivitySuccess = (activity) => ({ type: types.DIALOG_LOAD_ACTIVITY_SUCCESS, activity })
export const loadActivityFailure = (code, error) => ({ type: types.DIALOG_LOAD_ACTIVITY_FAILURE, code, error })

export const showViewCompanyDialog = (companyId) => ({ type: types.SHOW_VIEW_COMPANY_DIALOG, companyId})
export const showViewCompanyDialogForContact = (contactId) => ({ type: types.SHOW_VIEW_COMPANY_DIALOG_FOR_CONTACT, contactId})
export const hideViewCompanyDialog = () => ({ type: types.HIDE_VIEW_COMPANY_DIALOG})

export const viewCompanyDialogChangeTab = (tab) => ({type: types.VIEW_COMPANY_DIALOG_CHANGE_TAB, tab})
export const viewCompanyDialogSelectContact = (contactId) => ({type: types.VIEW_COMPANY_DIALOG_SELECT_CONTACT, contactId})

export const viewCompanyDialogCompanyLoad = (companyId) => ({type: types.VIEW_COMPANY_DIALOG_COMPANY_LOAD_ATTEMPT, companyId})
export const viewCompanyDialogCompanyLoadSuccess = (data) => ({ type: types.VIEW_COMPANY_DIALOG_COMPANY_LOAD_SUCCESS, data})
export const viewCompanyDialogCompanyLoadFailure = (message, code) => ({ type: types.VIEW_COMPANY_DIALOG_COMPANY_LOAD_FAILURE, message, code})

export const viewCompanyDialogContactLoad = (contactId) => ({type: types.VIEW_COMPANY_DIALOG_CONTACT_LOAD_ATTEMPT, contactId})
export const viewCompanyDialogContactLoadSuccess = (data) => ({ type: types.VIEW_COMPANY_DIALOG_CONTACT_LOAD_SUCCESS, data})
export const viewCompanyDialogContactLoadFailure = (message, code) => ({ type: types.VIEW_COMPANY_DIALOG_CONTACT_LOAD_FAILURE, message, code})

export const viewCompanyDialogUpdateActivityFilters = (filters) => ({ type: types.VIEW_COMPANY_DIALOG_ACTIVITIES_UPDATE_FILTERS, filters })
export const viewCompanyDialogUpdateDocumentFilters = (filters) => ({ type: types.VIEW_COMPANY_DIALOG_DOCUMENTS_UPDATE_FILTERS, filters })
export const viewCompanyDialogUpdateQuoteFilters = (filters) => ({ type: types.VIEW_COMPANY_DIALOG_QUOTES_UPDATE_FILTERS, filters })
export const viewCompanyDialogUpdateInvoiceFilters = (filters) => ({ type: types.VIEW_COMPANY_DIALOG_INVOICES_UPDATE_FILTERS, filters })

export const viewCompanyDialogDeleteDocuments = (documentIds) => ({type: types.VIEW_COMPANY_DIALOG_DELETE_DOCUMENTS_ATTEMPT, documentIds})
export const viewCompanyDialogLoadDocuments = (folder) => ({type: types.VIEW_COMPANY_DIALOG_LOAD_DOCUMENTS, folder})

export const viewCompanyDialogUploadDocuments = (documents) => ({type: types.VIEW_COMPANY_DIALOG_UPLOAD_DOCUMENTS_ATTEMPT, documents})
export const viewCompanyDialogUploadDocumentsSuccess = (data) => ({ type: types.VIEW_COMPANY_DIALOG_UPLOAD_DOCUMENTS_SUCCESS, data})
export const viewCompanyDialogUploadDocumentsFailure = (message, code) => ({ type: types.VIEW_COMPANY_DIALOG_UPLOAD_DOCUMENTS_FAILURE, message, code})

export const viewCompanyDialogAddFolder = (folder) => ({type: types.VIEW_COMPANY_DIALOG_DOCUMENTS_ADD_FOLDER, folder})

export const viewCompanyDialogLoadParentFolder = (companyId) => ({type: types.VIEW_COMPANY_DIALOG_DOCUMENTS_LOAD_PARENT_FOLDER_ATTEMPT, companyId})
export const viewCompanyDialogLoadParentFolderSuccess = (folder) => ({ type: types.VIEW_COMPANY_DIALOG_DOCUMENTS_LOAD_PARENT_FOLDER_SUCCESS, folder})
export const viewCompanyDialogLoadParentFolderFailure = (message, code) => ({ type: types.VIEW_COMPANY_DIALOG_DOCUMENTS_LOAD_PARENT_FOLDER_FAILURE, message, code})

export const viewCompanyDialogRemoveFolderAfterIndex = (index) => ({type: types.VIEW_COMPANY_DIALOG_DOCUMENTS_REMOVE_FOLDERS_AFTER_INDEX, index })
export const viewCompanyDialogSetFoldersToRootDirectory = (folder) => ({type: types.VIEW_COMPANY_DIALOG_DOCUMENTS_SET_FOLDERS_TO_ROOT_DIRECTORY, folder})

export const showAllocateContactListDialog = (contactList) => ({type: types.SHOW_ALLOCATE_CONTACT_LIST_DIALOG, contactList})
export const hideAllocateContactListDialog = () => ({type: types.HIDE_ALLOCATE_CONTACT_LIST_DIALOG})

export const showDeletePartCategoryDialog = (category) => ({ type: types.SHOW_DELETE_PART_CATEGORY_DIALOG, category})
export const hideDeletePartCategoryDialog = () => ({ type: types.HIDE_DELETE_PART_CATEGORY_DIALOG})

export const showDeletePartsPrompt = (partIds) => ({type: types.SHOW_DELETE_PARTS_PROMPT, data: partIds})
export const hideDeletePartsPrompt = () => ({type: types.HIDE_DELETE_PARTS_PROMPT})

export const showPartUsedInPricingCalculatorPrompt = (entityType) => ({type: types.SHOW_PART_USED_IN_PRICING_CALCULATOR_PROMPT, data: entityType})
export const hidePartUsedInPricingCalculatorPrompt = () => ({type: types.HIDE_PART_USED_IN_PRICING_CALCULATOR_PROMPT})

export const showMovePartCategoryDialog = (category) => ({ type: types.SHOW_MOVE_PART_CATEGORY_DIALOG, category})
export const hideMovePartCategoryDialog = () => ({ type: types.HIDE_MOVE_PART_CATEGORY_DIALOG})

export const showSetupJobCardDialog = (order) => ({ type: types.PRODUCTION_SHOW_SETUP_JOB_CARD_DIALOG, order})
export const hideSetupJobCardDialog = () => ({ type: types.PRODUCTION_HIDE_SETUP_JOB_CARD_DIALOG})

export const showViewJobCardDialog = (jobCard, order = null, jobCardReadOnly = false) => ({ type: types.PRODUCTION_SHOW_VIEW_JOB_CARD_DIALOG, jobCard, order, jobCardReadOnly})
export const hideViewJobCardDialog = () => ({ type: types.PRODUCTION_HIDE_VIEW_JOB_CARD_DIALOG})

export const showAddPurchaseOrderDialog = (copyFromId = null, purchaseOrder = null) => ({ type: types.SHOW_ADD_PURCHASE_ORDER_DIALOG, copyFromId, purchaseOrder})
export const hideAddPurchaseOrderDialog = () => ({ type: types.HIDE_ADD_PURCHASE_ORDER_DIALOG})
export const showAddItemsToPurchaseOrderDialog = () => ({ type: types.SHOW_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG})
export const hideAddItemsToPurchaseOrderDialog = () => ({ type: types.HIDE_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG})
export const addItemsToPurchaseOrderDialogUpdateFilters = (filters) => ({ type: types.PURCHASING_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG_UPDATE_FILTERS, filters })
export const addItemsToPurchaseOrderDialogSelectQuote = (orderId) => ({ type: types.PURCHASING_ADD_ITEMS_TO_PURCHASE_ORDER_DIALOG_SELECT_QUOTE, orderId })

export const showAddPurchaseInvoiceDialog = (purchaseOrder = null) => ({ type: types.SHOW_ADD_PURCHASE_INVOICE_DIALOG, purchaseOrder})
export const hideAddPurchaseInvoiceDialog = () => ({ type: types.HIDE_ADD_PURCHASE_INVOICE_DIALOG })

export const showMarkPurchaseOrderPaidDialog = (purchaseOrder = null) => ({ type: types.SHOW_MARK_PURCHASE_ORDER_PAID_DIALOG, purchaseOrder})
export const hideMarkPurchaseOrderPaidDialog = () => ({ type: types.HIDE_MARK_PURCHASE_ORDER_PAID_DIALOG })

export const showPostContactListDialog = (contactList, emailingIntegration) => ({ type: types.SHOW_POST_CONTACT_LIST_DIALOG, contactList, emailingIntegration})
export const hidePostContactListDialog = () => ({ type: types.HIDE_POST_CONTACT_LIST_DIALOG})

export const showPostContactDialog = (contact, emailingIntegration) => ({type: types.SHOW_POST_CONTACT_DIALOG, contact, emailingIntegration})
export const hidePostContactDialog = () => ({type: types.HIDE_POST_CONTACT_DIALOG})

export const showPrintTemplateDialog = (printTemplateGroupId, printTemplateId, printTemplateType, printTemplateRouteType) => ({type: types.SHOW_PRINT_TEMPLATE_DIALOG, printTemplateGroupId, printTemplateId, printTemplateType, printTemplateRouteType})
export const hidePrintTemplateDialog = () => ({type: types.HIDE_PRINT_TEMPLATE_DIALOG})

export const showAddUserDialog = () => ({type: types.SHOW_ADD_USER_DIALOG})
export const hideAddUserDialog = () => ({type: types.HIDE_ADD_USER_DIALOG})
export const updateAddUserDialog = (data) => ({type: types.UPDATE_ADD_USER_DIALOG, data})

export const showAddExternalUserDialog = () => ({type: types.SHOW_ADD_EXTERNAL_USER_DIALOG})
export const hideAddExternalUserDialog = () => ({type: types.HIDE_ADD_EXTERNAL_USER_DIALOG})
export const updateExternalAddUserDialog = (data) => ({type: types.UPDATE_ADD_EXTERNAL_USER_DIALOG, data})

export const showChartDialog = (index, layoutId, chart, isEditing) => ({type: types.SHOW_CHART_DIALOG, index, layoutId, chart, isEditing})
export const hideChartDialog = () => ({type: types.HIDE_CHART_DIALOG})

export const toggleJobCardJobAddressVisibility = () => ({type: types.PRODUCTION_TOGGLE_JOB_CARD_JOB_ADDRESS_VISIBILITY})

export const showEmailApprovalDialog = () => ({type: types.SHOW_EMAIL_APPROVAL_DIALOG, data: null})
export const hideEmailApprovalDialog = () => ({type: types.HIDE_EMAIL_APPROVAL_DIALOG})

export const maximiseJobCardDialogView = () => ({type: types.PRODUCTION_MAXIMISE_JOB_CARD_DIALOG})
export const restoreJobCardDialogView = () => ({type: types.PRODUCTION_RESTORE_JOB_CARD_DIALOG})

export default {
  showAddContactDialog,
  showEditContactDialog,
  hideContactDialog,
  showAddCompanyDialog,
  showEditCompanyDialog,
  hideCompanyDialog,
  showAddQuoteDialog,
  hideAddQuoteDialog,
  showAddInvoiceDialog,
  hideAddInvoiceDialog,
  showAddBulkInvoicesDialog,
  hideAddBulkInvoicesDialog,
  updateAddBulkInvoicesDialog,
  showAddActivityDialog,
  hideAddActivityDialog,
  showEditActivityDialog,
  hideEditActivityDialog,
  loadActivity,
  loadActivitySuccess,
  loadActivityFailure,
  showSetupJobCardDialog,
  hideSetupJobCardDialog,
  showViewJobCardDialog,
  hideViewJobCardDialog,
}
